module.exports = __webpack_public_path__ + "public/images/about-6.ac0356a2485fdb642bf41bef98968af7.png";